module.exports = __webpack_public_path__ + "img/bg_without_all.f46de8df.png";